export default __webpack_public_path__ + "static/media/929.a41cb5d0.JPG";